import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "bm_cookie_consent_v1";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) {
            const t = setTimeout(() => setVisible(true), 800);
            return () => clearTimeout(t);
        }
    }, []);

    const setConsent = (value) => {
        localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ value, at: new Date().toISOString() }),
        );
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            className="fixed left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md bottom-24 sm:bottom-6 z-[60] bg-[#111113] border border-[#C4A977]/40 rounded-sm p-5 lg:p-6 shadow-2xl"
        >
            <div className="flex items-start gap-4">
                <div className="w-10 h-10 shrink-0 border border-[#C4A977]/40 grid place-items-center text-[#C4A977]">
                    <Cookie size={16} />
                </div>
                <div className="flex-1">
                    <p className="overline">Kakor</p>
                    <p className="mt-2 text-sm text-[#F4F4F5]/90 leading-relaxed">
                        Vi använder nödvändiga kakor för att sajten ska fungera
                        samt valfria analyskakor för att förbättra upplevelsen.
                        Läs mer i vår{" "}
                        <Link
                            to="/integritetspolicy"
                            className="text-[#C4A977] hover:underline"
                        >
                            integritetspolicy
                        </Link>
                        .
                    </p>
                    <div className="mt-4 flex flex-wrap gap-2">
                        <button
                            data-testid="cookie-accept"
                            onClick={() => setConsent("all")}
                            className="px-4 py-2 text-xs bg-[#C4A977] text-black hover:bg-[#DBC08F] rounded-sm tracking-wide"
                        >
                            Acceptera alla
                        </button>
                        <button
                            data-testid="cookie-necessary"
                            onClick={() => setConsent("necessary")}
                            className="px-4 py-2 text-xs border border-white/15 hover:border-[#C4A977] hover:text-[#C4A977] rounded-sm tracking-wide"
                        >
                            Endast nödvändiga
                        </button>
                    </div>
                </div>
                <button
                    data-testid="cookie-dismiss"
                    aria-label="Stäng"
                    onClick={() => setConsent("necessary")}
                    className="text-[#A1A1AA] hover:text-[#F4F4F5] transition-colors"
                >
                    <X size={16} />
                </button>
            </div>
        </div>
    );
}
